__turbopack_context__.v({
  "card": "_66Ff9W_card",
  "control-elements": "_66Ff9W_control-elements",
  "period-btn": "_66Ff9W_period-btn",
  "period-dropdown": "_66Ff9W_period-dropdown",
  "period-selection": "_66Ff9W_period-selection",
  "toggle": "_66Ff9W_toggle",
});
